export default __webpack_public_path__ + "static/media/logo_autorepair.9518f1d3.svg";